// extracted by css-extract-rspack-plugin
export default {"root":"NTLBlG","traded":"wkHrAt","icon":"HWWU2g","warning":"akG735"};